import { render, staticRenderFns } from "./ShiftEditorEmployee.vue?vue&type=template&id=16c045b8&scoped=true&lang=pug&"
import script from "./ShiftEditorEmployee.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c045b8",
  null
  
)

export default component.exports